import React from 'react';
import { Box, Typography, Paper, LinearProgress } from '@mui/material';

export default function LeaderPerformanceCard({ leader, score, onLeaderClick }) {
  return (
    <Paper 
      elevation={3} 
      sx={{
        p: 2,
        borderRadius: '12px',
        cursor: 'pointer',
        '&:hover': { boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.2)' },
        transition: 'box-shadow 0.3s ease-in-out',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
      onClick={() => onLeaderClick && onLeaderClick(leader)}
    >
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>{leader}</Typography>
        <Typography variant="body2" color="text.secondary">Puntaje Promedio Calibrado:</Typography>
        <Typography variant="h5" color="primary" sx={{ fontWeight: 'bold' }}>{score.toFixed(2)}</Typography>
      </Box>
      <Box mt={2}>
        <LinearProgress 
          variant="determinate" 
          value={(score / 5) * 100} 
          sx={{ height: 8, borderRadius: 4, backgroundColor: '#e0e0e0' }}
        />
        <Typography variant="caption" color="text.secondary" mt={0.5} textAlign="right">
          {((score / 5) * 100).toFixed(0)}% del máximo
        </Typography>
      </Box>
    </Paper>
  );
} 